"use strict";

(function () {
  'use strict';

  function AccountCtrl($window, $state) {
    var vm = this;
    this.navItems = [// {
    //     name: 'Account',
    //     state: 'account.home',
    //     icon: 'fa fa-home'
    // },
    {
      name: 'Profile',
      state: 'account.profile',
      icon: 'fa fa-user'
    }, {
      name: 'Connections',
      state: 'account.connections',
      icon: 'fa fa-user'
    }];

    this.$onInit = function () {};
  }

  AccountCtrl.$inject = ['$window', '$state'];
  angular.module('view.account', ['ui.router']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('account', {
      template: '<account />',
      title: 'Account'
    }).state('account.home', {
      parent: 'account',
      url: '/account',
      template: '<account-home />',
      title: 'Account Home'
    }).state('account.profile', {
      parent: 'account',
      url: '/account/profile',
      template: '<profile />',
      title: 'Profile'
    }).state('account.connections', {
      parent: 'account',
      url: '/account/connections',
      template: '<connections />',
      title: 'Connections'
    });
  }]).component('account', {
    bindings: {},
    controller: AccountCtrl,
    templateUrl: 'views/account/account.html'
  });
})();